export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";